var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-values",class:_vm.$mq},[_c('div',{staticClass:"container"},_vm._l((_vm.values),function(value){return _c('div',{key:value,staticClass:"item",class:{ portrait: ['portrait'].includes(_vm.$mq) },on:{"click":function($event){return _vm.emitValue(value)}}},[_vm._v(" "+_vm._s(_vm.formatValue(value))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }